import React from 'react';

class BroodHTMLSlide extends React.Component {
	constructor(props) {
		super(props);

		const {
			slide
		} = props;

		this.state = {
			// playing: props.status.playing,
			secondsRemaining: (slide.options.duration / 1000),
			hasError: false
		};
	}

	componentDidMount() {
		this.startTimers();
		this.checkForHTMLErrors();
	}

	componentDidCatch(error, errorInfo) {
		this.handleHTMLError(error);
	}

	checkForHTMLErrors() {
		// Simple check after mount - don't rely on ref since we return the element directly
		setTimeout(() => {
			// Check if the slide failed to render properly
			const elements = document.querySelectorAll('.html-slide, [data-html-slide]');
			if (elements.length === 0 && this.props.curr) {
				// Only error if we're the current slide and no HTML slide elements exist
				// This is a very conservative check
			}
		}, 1000);
	}

	handleHTMLError(error) {
		const { slideshow, slide, curr } = this.props;
		
		if (this.state.hasError) return; // Prevent multiple error calls
		
		this.setState({ hasError: true });
		
		// Stop timers to prevent auto-advance
		this.stopTimers();
		
		if (curr && slideshow) {
			slideshow.next(slide, curr, {
				error: error
			});
		}
	}

	componentWillUnmount() {
		this.stopTimers();
	}

	componentDidUpdate(prevProps) {
		const {
			status
		} = this.props;

		if (prevProps.status.playing !== status.playing) {
			if (status.playing) {
				let resume = true;
				this.startTimers(resume);
			} else {
				this.stopTimers();
			}
		}

		if (prevProps.status.slideLoopCount !== status.slideLoopCount) {
			// slideshow.next() has no next slide currently
			// so we need to check if the slideLoopCount has changed
			// and if so, reset the timer to loop this slide again
			if (status.slideLoopCount > 0) {
				this.stopTimers();

				this.setState({
					secondsRemaining: (this.props.slide.options.duration / 1000)
				}, () => {
					let resume = false;
					this.startTimers(resume);
				});
			}
		}

		if (prevProps.curr !== this.props.curr && this.props.curr) {
			this.stopTimers();

			this.setState({
				secondsRemaining: (this.props.slide.options.duration / 1000)
			}, () => {
				let resume = false;
				this.startTimers(resume);
			});
		}

		// console.log('UPDATE', prevProps, this.props);
	}

	startTimers(resume = false) {
		const {
			curr,
			slideshow,
			slide,
			slide: {
				options
			}
		} = this.props;

		let {
			duration
		} = options;

		const {
			secondsRemaining
		} = this.state;

		if (resume) {
			duration = (secondsRemaining * 1000);
		}

		// Mark the play start for /brood/pop like BroodImageSlide does —
		// without it html slides (MockNova ads) never record a PoP row
		// because buildBroodProofOfPlayBody treats the play as never having
		// happened. Fresh starts only: a resume continues the same play.
		if (!resume && curr) {
			slideshow.broodProofOfPlayStart(slide);
		}

		this.nextSlideTimer = setTimeout(() => {
			slideshow.next();
		}, duration + 500); // add 500ms to account for transition

		this.secondsRemainingCountdownInterval = setInterval(() => {
			this.setState({
				secondsRemaining: (this.state.secondsRemaining - 1)
			});
		}, 1000);
	}

	stopTimers() {
		clearTimeout(this.nextSlideTimer);
		clearInterval(this.secondsRemainingCountdownInterval);
	}

	renderControls() {
		const {
			status,
			slideshow
		} = this.props;

		return (
			<>
				<button
					disabled={status.playing}
					onClick={() => {
						slideshow.play();
					}}
				>PLAY</button>
				&nbsp;
				<button
					onClick={() => {
						slideshow.stop();
					}}
				>STOP</button>
				&nbsp;
				<button
					onClick={() => {
						slideshow.next();
					}}
				>NEXT</button>
			</>
		);
	}

	render() {
		const {
			slide,
			className: slideClassName,
		} = this.props;

		let {
			secondsRemaining,
			hasError
		} = this.state;

		if (!this.props.curr) {
			return null;
		}

		if (hasError) {
			return (
				<div
					className={slideClassName}
					style={{
						color: 'red',
						textAlign: 'center',
						padding: '20px'
					}}
				>
					HTML Slide Error: Failed to load content
				</div>
			);
		}

		// React 19 fix: Wrap HTML content in a container with slide positioning classes
		// to prevent cropping and ensure proper positioning within the slideshow
		return (
			<div
				className={slideClassName}
				style={{ width: '100%', height: '100%' }}
			>
				{slide.data.html}
			</div>
		);
	}
}

export default BroodHTMLSlide; 